import type { NextPageContext } from "next";
import type { IStorage } from "@interfaces";
import type { WithRequired } from "@utils/WithRequired";
import type { ServerSideStorage } from "./serverSide";
import type { ClientSideStorage } from "./clientSide";

export type StorageDependencies = {
	globalContext: NextPageContext | null;
};

const Storage = ({ globalContext }: StorageDependencies): IStorage => {
	if (typeof window === "undefined") {
		const {
			default: storageFactory,
		}: ServerSideStorage = require("./serverSide");
		return storageFactory(
			globalContext as WithRequired<NextPageContext, "req" | "res">,
		);
	}
	const {
		default: storageFactory,
	}: ClientSideStorage = require("./clientSide");
	return storageFactory();
};

export default Storage;
